export default __webpack_public_path__ + "static/media/emptySchedule.6e2177ef.svg";